import { take, call, put, fork } from 'redux-saga/effects';
import { fetchYear, failFetchYear, successFetchYear } from '../actions/year';
import superFetch from '../modules/superFetch';
import { actions } from 'react-redux-form';
import store from '../store/configureStore';

// stateの状態変更を行っている
export function* handleFetchYear() {
  while (true) {
    yield take(`${fetchYear}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/year/',
      type: 'GET',
    });

    if (payload && !err) {
      yield put(successFetchYear(payload));
      yield store.dispatch(
        actions.change('forms.prediction.test_date', payload.test_date)
      );
      continue;
    }
    if (!payload && err) {
      yield put(failFetchYear(String(err)));
      continue;
    }
  }
}

//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handleFetchYear);
}



// WEBPACK FOOTER //
// ./src/sagas/year.js